/**
 * Labstep
 *
 * @module containers/Stripe
 * @desc Container to call Stripe endpoints
 */

import type { APICallOptions } from 'labstep-web/models';
import {
  createStripeBillingPortalSessionAction,
  createStripeBillingPortalSessionActionType,
  createStripeCheckoutSessionAction,
  createStripeCheckoutSessionActionType,
  type ICreateStripeBillingPortalSessionBody,
  type ICreateStripeCheckoutSessionBody,
} from 'labstep-web/state/actions/stripe';
import { selectApiStatus } from 'labstep-web/state/selectors/ui';
import type { LabstepReduxState } from 'labstep-web/state/types';
import { connect } from 'react-redux';
import type { StripeContainerProps } from './types';

const Container = ({ children, ...rest }) => children(rest);

const mapStateToProps = (state: LabstepReduxState) => ({
  createStripeCheckoutSessionStatus: selectApiStatus(
    state,
    createStripeCheckoutSessionActionType,
  ),
  createBillingPortalSessionStatus: selectApiStatus(
    state,
    createStripeBillingPortalSessionActionType,
  ),
});

const mapDispatchToProps = (dispatch) => ({
  createStripeCheckoutSession(
    body: ICreateStripeCheckoutSessionBody,
    options?: APICallOptions,
  ) {
    dispatch(createStripeCheckoutSessionAction(body, options));
  },
  createStripeBillingPortalSession(
    body: ICreateStripeBillingPortalSessionBody,
    options?: APICallOptions,
  ) {
    dispatch(createStripeBillingPortalSessionAction(body, options));
  },
});

export const StripeContainer: React.FC<StripeContainerProps> =
  connect(mapStateToProps, mapDispatchToProps)(Container);
